import { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { MapPin, X } from 'lucide-react';

interface EventLocationMapProps {
  location: string;
  eventTitle: string;
}

const EventLocationMap = ({ location, eventTitle }: EventLocationMapProps) => {
  const [showMap, setShowMap] = useState(false);

  const handleViewLocation = () => {
    setShowMap(true);
  };

  const handleClose = () => {
    setShowMap(false);
  };

  // Generate Google Maps embed URL
  const getMapUrl = (location: string) => {
    const encodedLocation = encodeURIComponent(location);
    return `https://maps.google.com/maps?q=${encodedLocation}&output=embed`;
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={handleViewLocation}
        className="flex items-center gap-2"
      >
        <MapPin className="w-4 h-4" />
        View Location
      </Button>

      <Dialog open={showMap} onOpenChange={setShowMap}>
        <DialogContent className="max-w-4xl w-full h-[80vh] p-0 overflow-hidden">
          <div className="relative w-full h-full">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleClose}
              className="absolute top-4 right-4 z-10 bg-white/80 hover:bg-white"
            >
              <X className="w-4 h-4" />
            </Button>
            
            {/* Only Map - No Image */}
            <div className="w-full h-full">
              <iframe
                src={getMapUrl(location)}
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Map of ${location}`}
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EventLocationMap;